module.exports = __webpack_public_path__ + "img/Personal.bb0a7682.jpg";